/* Add breakpoints to use with "react-responsive" */
import useMediaQuery from './useMediaQuery'

export const SMALL = 460;
export const MEDIUM = 768;
export const XLARGE = 1024; //tablet

export const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: MEDIUM });
    return isDesktop ? children : null
};

export const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: MEDIUM - 1 });
    return isMobile ? children : null
};

export const Phone = ({ children }) => {
    const isPhone = useMediaQuery({ maxWidth: SMALL - 1 });
    return isPhone ? children : null
};